'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getItem = getItem;
exports.setItem = setItem;
exports.removeItem = removeItem;
function getItem(item) {
    try {
        return JSON.parse(localStorage.getItem(item));
    } catch (e) {
        return null;
    }
}

function setItem(item, value) {
    try {
        localStorage.setItem(item, JSON.stringify(value));
    } catch (e) {
        throw {
            message: 'localStorage setItem failed',
            e: e
        };
    }
}

function removeItem(item) {
    localStorage.removeItem(item);
}


//////////////////
// WEBPACK FOOTER
// ./src/js/utils/local_storage.js
// module id = 866
// module chunks = 0